<template>
	<DialogHeader closable class="py-4" @cancel="$emit('cancel')" />
	<DialogBody>
		<Cover class="rounded-4" width="100%" height="157px" :src="banner" />
		<h1 class="mt-4 text-title-m text-neutral-950">{{ $t('common.app_download.title') }}</h1>
		<p class="mt-2 text-body-l text-neutral-950">{{ $t('common.app_download.description') }}</p>
		<div class="d-flex mt-3 gap-5">
			<img v-if="!isXS" :src="qrCode" height="124px" />
			<div class="d-flex flex-column">
				<p v-if="!isXS" class="text-body-l text-neutral-950 font-weight-bold">
					{{ $t('common.app_download.qr.title') }}
				</p>
				<p v-if="!isXS" class="mt-1 text-body-l text-neutral-950">
					{{ $t('common.app_download.qr.description') }}
				</p>
				<div class="d-flex mt-3 gap-3">
					<a :href="Settings.iosDownloadLink()" target="_blank" rel="noopener">
						<img :src="appleStore" height="40px" />
					</a>
					<a :href="Settings.androidDownloadLink()" target="_blank" rel="noopener">
						<img :src="googlePlay" height="40px" />
					</a>
				</div>
			</div>
		</div>
	</DialogBody>
</template>
<script setup lang="ts">
	import banner from '~/assets/profile/profileDestinations/donwloadApp.png'
	import qrCode from '~/assets/profile/profileDestinations/downloadAppQr.svg'
	import appleStore from '~/assets/appleStore.png'
	import googlePlay from '~/assets/googlePlay.png'
	import Settings from '~/services/settings'

	interface Props {
		isXS: boolean
	}
	defineProps<Props>()
	defineEmits(['cancel'])
</script>
